/**
 * users.js
 * Written by: Alex Kasemir
 */

/**
 * Description of the users reducer
 */
const users = (state = {}, action) => {
  switch (action.type) {
    case `GET_BADGE_PLACEMENTS_SUCCESS`:
      return {
        ...state,
        [action.user]: {
          ...state[action.user],
          ...action.data,
        },
      };
    default:
      return state;
  }
};

export default users;
